import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: '', redirectTo: 'verify', pathMatch: 'full' },
  {
    path: 'verify',
    loadComponent: () =>
      import('./features/challenge/challenge').then((m) => m.ChallengeComponent),
  },
  {
    path: 'upload',
    loadComponent: () =>
      import('./features/upload/upload').then((m) => m.UploadComponent),
  },
  {
    path: 'success',
    loadComponent: () =>
      import('./features/success/success').then((m) => m.SuccessComponent),
  },
  {
    path: 'error',
    loadComponent: () =>
      import('./features/error-state/error-state').then((m) => m.ErrorStateComponent),
  },
  { path: '**', redirectTo: 'verify' },
];
